import { useState } from 'react';
import { Download, FileText, Loader2 } from 'lucide-react';
import { downloadPrivateFile } from '@/shared/lib/utils/privateFiles';
import type { FileInfo } from '@/shared/types/files';
import pdfIcon from '@/shared/assets/icons/file-type-pdf.svg?url';

const isPdf = (file: FileInfo) =>
  file.mime === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');

export const FileDownloadRow = ({ file }: { file: FileInfo }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      await downloadPrivateFile(file);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-between gap-4 rounded-2xl bg-neutral-hover px-4 py-3">
      <div className="flex min-w-0 items-center gap-3">
        {isPdf(file) ? (
          <img src={pdfIcon} alt="" className="h-10 w-10 shrink-0" />
        ) : (
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white">
            <FileText className="h-5 w-5 text-black" />
          </div>
        )}
        <p className="truncate text-base font-medium leading-[120%] text-black">{file.name}</p>
      </div>
      <button
        type="button"
        disabled={isLoading}
        onClick={handleDownload}
        aria-label={`Download ${file.name}`}
        className="inline-flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full text-black transition hover:bg-white disabled:cursor-default disabled:opacity-60"
      >
        {isLoading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Download className="h-5 w-5" />}
      </button>
    </div>
  );
};
